export default {
  isAuthenticated(state) {
    return !!state.token;
  },
  currentRole(state) {
    return state.role;
  },
};
